import api from '..'

const downloadCoursesEvaluations = (allSelected = false, courseIds: any[], q: any) => {
  return api.post('administration/courses/download_evaluations', {
    courseIds: allSelected ? [] : courseIds,
    excludeCourseIds: allSelected ? courseIds : [],
    selectAll: allSelected,
    q,
  })
}

export default downloadCoursesEvaluations
